import Log from '../_Utility/Log';
import ReView from '../ReView';

class EventPopup {

    /**
     * @method constructor
     */
    constructor() {
        // Set up variables
        this.selector    = '[data-event-popper]';
        this.openDelay   = 200;
        this.closeDelay  = 100;
        this.openTimers  = {};
        this.closeTimers = {};

        // Run initialization
        this.init();
    }

    /**
     * Initialize the class.
     *
     * @since 2.14.0
     * @method init
     * @return void
     */
    init() {
        // Let them know we made it here OK
        new Log('EventPopup initialized.', 'init');

        // Run it
        this.run();
    }

    /**
     * Get the popup for a trigger.
     *
     * @since 2.14.0
     * @method get_popup
     * @param object trigger is the trigger element or jQuery object
     * @return object|null
     */
    get_popup(trigger) {
        // Declare and initialize
        let me   = $(trigger);
        let id   = me.data('event-popper');
        let them = $('[data-event-popup="' + id + '"]');

        // No pop!
        if (!them.length)
            return null;

        // We got em
        return them[0];
    }

    /**
     * Clear the pending open timer for a popup id.
     *
     * @since 2.14.0
     * @method clearOpenTimer
     * @param string id is the popup id
     * @return void
     */
    clearOpenTimer(id) {
        // No timer? No problem
        if (!this.openTimers[id])
            return;

        // Remove the open timer
        clearTimeout(this.openTimers[id]);
        delete this.openTimers[id];
    }

    /**
     * Clear the pending close timer for a popup id.
     *
     * @since 2.14.0
     * @method clearCloseTimer
     * @param string id is the popup id
     * @return void
     */
    clearCloseTimer(id) {
        // No timer? No problem
        if (!this.closeTimers[id])
            return;

        // Remove the closed timers
        clearTimeout(this.closeTimers[id]);
        delete this.closeTimers[id];
    }

    /**
     * Clear all pending timers for a popup id.
     *
     * @since 2.14.0
     * @method clearTimers
     * @param string id is the popup id
     * @return void
     */
    clearTimers(id) {
        // Clear all timers
        this.clearOpenTimer(id);
        this.clearCloseTimer(id);
    }

    /**
     * Fully close a popup after the transition has completed.
     *
     * @since 2.14.0
     * @method bindTransitionEnd
     * @param object popup is the popup element
     * @return void
     */
    bindTransitionEnd(popup) {
        // Already bound?
        if (popup.dataset.eventPopupTransitionBound === 'true')
            return;

        // We are transitioning
        popup.dataset.eventPopupTransitionBound = 'true';

        // Listen for when the transition ends
        popup.addEventListener('transitionend', e => {

            // Only care about the popover itself
            if (e.target !== popup)
                return;

            // Only care about opacity finishing
            if (e.propertyName !== 'opacity')
                return;

            // Finalize closed state
            if (popup.dataset.state === 'closing')
                popup.dataset.state = 'closed';

        });
    }

    /**
     * Queue a popup to open after a short delay.
     *
     * @since 2.14.0
     * @method queueOpen
     * @param string id is the popup id
     * @param object popper is the trigger element
     * @param object popup is the popup element
     * @return void
     */
    queueOpen(id, popper, popup) {
        // Reset any existing timers first
        this.clearTimers(id);

        // Queue it up
        this.openTimers[id] = setTimeout(() => {

            // Open it up
            this.openPopup(popper, popup);

            // Trash the record
            delete this.openTimers[id];

        }, this.openDelay);
    }

    /**
     * Queue a popup to close after a short delay.
     *
     * @since 2.14.0
     * @method queueClose
     * @param string id is the popup id
     * @param object popup is the popup element
     * @return void
     */
    queueClose(id, popup) {
        // Reset any existing timers first
        this.clearTimers(id);

        // Run the close on a delay
        this.closeTimers[id] = setTimeout(() => {

            // Move into closing state
            popup.dataset.state = 'closing';

            // Trash the record
            delete this.closeTimers[id];

        }, this.closeDelay);
    }

    /**
     * Open and position a popup.
     *
     * @since 2.14.0
     * @method openPopup
     * @param object popper is the trigger element
     * @param object popup is the popup element
     * @return void
     */
    openPopup(popper, popup) {
        // Declare and initialize
        let rect;
        let popupRect;
        let top;
        let left;
        let gap         = 12;
        let edgePadding = 12;
        let viewportMid;
        let maxHeight;
        let placeRight;

        // Open first so we can measure it
        popup.dataset.state = 'open';

        // Get trigger rect
        rect = popper.getBoundingClientRect();

        // Set max height before measurement
        maxHeight             = window.innerHeight - (edgePadding * 2);
        popup.style.maxHeight = maxHeight + 'px';

        // Measure popup after showing it
        popupRect = popup.getBoundingClientRect();

        // Figure out which side to use
        viewportMid = window.innerWidth / 2;
        placeRight  = rect.left < viewportMid;

        // Horizontal position
        if (placeRight)
            left = rect.right + gap;
        else
            left = rect.left - popupRect.width - gap;

        // Vertical position
        top = rect.top + ((rect.height - popupRect.height) / 2);

        // Clamp vertically into viewport
        top = Math.max(edgePadding, Math.min(top, window.innerHeight - popupRect.height - edgePadding));

        // If preferred side would overflow, flip it
        if (placeRight && ((left + popupRect.width + edgePadding) > window.innerWidth))
            left = rect.left - popupRect.width - gap;
        else if (!placeRight && (left < edgePadding))
            left = rect.right + gap;

        // Final horizontal clamp just in case
        left = Math.max(edgePadding, Math.min(left, window.innerWidth - popupRect.width - edgePadding));

        // Apply position
        popup.style.top  = top + 'px';
        popup.style.left = left + 'px';
    }

    /**
     * Run the view refresh.
     *
     * @since 2.14.0
     * @method run
     * @return void
     */
    run() {
        // None? Non
        if (!$(this.selector).length)
            return;

        // How many of you are there
        $(this.selector).each((i, ele) => {

            // Avoid duplicate listeners if this gets re-run
            if (ele.dataset.eventPopupBound === 'true')
                return;

            ele.dataset.eventPopupBound = 'true';

            // Declare and initialize
            let me    = $(ele);
            let id    = me.data('event-popper');
            let popup = this.get_popup(ele);

            // No pop!
            if (!popup)
                return;

            // Make sure the transition handler is bound
            this.bindTransitionEnd(popup);

            // Bind popup once too
            if (popup.dataset.eventPopupBound !== 'true') {
                popup.dataset.eventPopupBound = 'true';

                // Show on mouse in
                $(popup).on('mouseenter', () => {

                    // Clear it
                    this.clearTimers(id);

                    // Show it
                    popup.dataset.state = 'open';

                });

                // Hide on mouse out
                $(popup).on('mouseleave', () => {

                    // Queue up the close
                    this.queueClose(id, popup);

                });
            }

            // Hey! LISTEN!
            $(ele).on('mouseenter', e => {

                // Declare and initialize
                let trigger = e.currentTarget;

                // Queue opening
                this.queueOpen(id, trigger, popup);

            });

            // Hey! STOP LISTENING!
            $(ele).on('mouseleave', () => {

                // Start the queue for closing
                this.queueClose(id, popup);

            });

            // Nice for keyboard users too
            $(ele).on('focus', e => {

                // Declare and initialize
                let trigger = e.currentTarget;

                // Open it up right away
                this.clearTimers(id);
                this.openPopup(trigger, popup);

            });

            // Blur for keyboard users
            $(ele).on('blur', () => {

                // Queue up closing time
                this.queueClose(id, popup);

            });

        });
    }

}

export default EventPopup;